(function () {
  'use strict';

  angular.module('app').component('packageContentList', packageContentList());

  function packageContentList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onPackageContentShowed: '&',
        websiteId: '<',
        defaultLanguage: '<',
      },
      controller: PackageContentListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/package-contents/package-content-list/package-content-list.component.html',
    };
  }

  PackageContentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'PackageContentService',

    // Angular downgraded service
    'locationService',
  ];

  function PackageContentListComponent(
    config,
    UtilService,
    AbilityService,
    PackageContentService,

    // Angular downgraded service
    locationService
  ) {
    let vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_package_accountadmin'),
      canUpdate: AbilityService.can('update_package_accountadmin'),
      canDestroy: AbilityService.can('destroy_package_accountadmin'),
    };

    vm.featuredOptions = config.BOOLEAN_OPTIONS;
    vm.publishedOptions = config.BOOLEAN_OPTIONS;

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = PackageContentService.getFilterCriteria();

    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showItem = showItem;
    vm.deleteItem = deleteItem;
    vm.changeItemStatus = changeItemStatus;
    // vm.onUpdateItems       = onUpdateItems;
    vm.changeItemFeatured = changeItemFeatured;
    vm.changeItemPublished = changeItemPublished;

    vm.searchLocations = (search, option) => {
      if (search.length < 2) {
        return;
      }

      let params = {
        get: 'active',
        by_name: search,
        skip_check_role: true,
        lang: vm.defaultLanguage,
      };

      locationService.getLocations(params).subscribe((response) => {
        let locations = response;

        if (option === 'departure') {
          vm.departureLocations = locations;
        } else {
          vm.arrivalLocations = locations;
        }
      });
    };

    vm.clearLocations = (option) => {
      if (option === 'departure') {
        vm.departureLocations = [];
      } else {
        vm.arrivalLocations = [];
      }

      vm.UtilService.filterResult();
    };

    function fetchResult() {
      vm.filterCriteria.lang = vm.defaultLanguage;

      vm.loadingItems = true;
      PackageContentService.getPackagesContents(vm.websiteId, vm.filterCriteria).then(function (
        data
      ) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;

        vm.showActions = false;
        vm.selectedAll = false;
      });
    }

    // refresh the data with the default filter criteria
    function refresh() {
      vm.departureLocations = [];
      vm.arrivalLocations = [];

      vm.filterCriteria = PackageContentService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;
      fetchResult();
    }

    function showItem(item) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onPackageContentShowed({ item: item });
    }

    function deleteItem(item) {
      if (!vm.permissions.canDestroy) {
        return;
      }

      PackageContentService.deletePackageContent(item, fetchResult);
    }

    function changeItemStatus(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      PackageContentService.changePackageContentStatus(item);
    }

    /*function onUpdateItems(action) {
            let successCallback = function(){
                vm.showActions = false;
                vm.selectedAll = false;

                if (action === 'destroy'){
                    fetchResult();
                }
            };

            PackageContentService.updatePackagesContents(action, vm.items, successCallback);
        }*/

    function changeItemFeatured(item) {
      PackageContentService.changePackageContentFeatured(item);
    }

    function changeItemPublished(item) {
      if (!vm.permissions.canUpdate) {
        return;
      }

      PackageContentService.changePackageContentPublished(item);
    }
  }
})();
